import StoreContainer from "./StoreContainer";

export default StoreContainer;